import {SmartComponent} from "smart-component-js";

class MissionTabsComponent extends SmartComponent {

    constructor(element, parentComponent, params) {
        super(element, parentComponent, params);
        this.element = element;
        this.user = this.element.querySelector('div[data-user]')?.getAttribute('data-user');
        this.init();
    }


    checkMissionsStatus() {
        this.completedMissions = document.querySelectorAll('.yxp-mission-COMPLETED');
        this.availableMissions = document.querySelectorAll('.yxp-mission-ACTIVE');
        if (!this.completedMissions.length && !this.availableMissions.length) return; // no missions


        if (this.completedMissions.length) this.element.classList.remove('hidden');
        this.completedMissions.forEach((el) => el.classList.add('hidden'));
        if (this.availableMissions.length === 0) {
            document.querySelector('.mission-tabs-no-results').classList.remove('yxpHidden');
        }
        this.addButtonListener();
    }

    addButtonListener() {
        this.element.querySelector('button[data-status="AVAILABLE"]').addEventListener('click', (e) => {
            this.changeSelection(e.target, this.availableMissions, this.completedMissions);
            if (this.availableMissions.length === 0) {
                document.querySelector('.mission-tabs-no-results').classList.remove('yxpHidden');
            }
        });

        this.element.querySelector('button[data-status="COMPLETED"]').addEventListener('click', (e) => {
            document.querySelector('.mission-tabs-no-results').classList.add('yxpHidden');
            this.changeSelection(e.target, this.completedMissions, this.availableMissions);
        });
    }

    changeSelection(button, visibleMission, hiddenMission) {
        if (button.classList.contains('active')) return;
        this.element.querySelector('.mission-tabs__button.active').classList.remove('active');
        button.classList.add('active');
        hiddenMission.forEach((el) => el.classList.add('hidden'));
        visibleMission.forEach((el) => el.classList.remove('hidden'));
    }
    

    init() {
        document.addEventListener('yxp-mission-list-ok', () => this.checkMissionsStatus());
    }
}

export default MissionTabsComponent;
